import axios from 'axios'

const EUROPEAN_CUP_BERN_2019_ID = 68

const countryNames = {
  'CHN': 'China',
  'FIN': 'Finland',
  'FRA': 'France',
  'ITA': 'Italy',
  'KOR': 'South Korea',
  'RUS': 'Russia',
  'SUI': 'Switzerland',
  'USA': 'USA'
}

class UiaaApi {
  setBaseUrl (baseUrl) {
    this.baseUrl = baseUrl + '/ajax/'
    return this
  }

  getUrl (name, competitionId, stageId, roundId) {
    let result = this.baseUrl + 'Get' + name + '.php'
    if (competitionId) {
      result += '?Competition=' + competitionId
      if (stageId) {
        result += '&Stage=' + stageId
        if (roundId) {
          result += '&Round=' + roundId
        }
      }
    }
    return result
  }

  fetchCompetitions () {
    return axios.get(this.getUrl('Competitions'))
      .catch(err => {
        console.error('[uiaa/api] error fetching competitions', err)
        return {data: null}
      })
      .then(({data}) => {
        return ((data && data.Competitions[0]) || [])
          .concat([{
            id: EUROPEAN_CUP_BERN_2019_ID,
            name: '2019 UIAA European Cup',
            date: '23 Nov',
            location: 'Bern (SUI)',
            shortname: 'Bern'
          }, {
            id: 69,
            name: '2018 UIAA Ice Climbing World Cup',
            date: '02 - 04 Mar',
            location: 'Kirov (RUS)',
            shortname: 'Kirov'
          }])
          .map(each => {
            const country = each.location.match(/\((.*)\)/)[1]
            return {
              id: each.id,
              name: each.name,
              date: each.date,
              location: each.location,
              city: each.shortname,
              country: countryNames[country],
              destination: each.shortname + ', ' + countryNames[country]
            }
          })
      })
  }

  fetchStages (competitionId) {
    if (competitionId === EUROPEAN_CUP_BERN_2019_ID) {
      return new Promise(function (resolve) {
        resolve([{id: 1, name: 'Men Lead', competitionId}, {id: 2, name: 'Women Lead', competitionId}])
      })
    }
    return axios.get(this.getUrl('Competitions', competitionId))
      .then(({data}) => {
        return (data.CompetitionStages[0] || []).map(each => {
          each.competitionId = competitionId
          return each
        })
      })
  }

  fetchRounds (competitionId, stageId) {
    if (competitionId === EUROPEAN_CUP_BERN_2019_ID) {
      return new Promise(function (resolve) {
        if (stageId === 1) {
          resolve([
            {id: 84, name: 'Qualification', competitionId, stageId},
            {id: 86, name: 'Final', competitionId, stageId}
          ])
        } else if (stageId === 2) {
          resolve([
            {id: 85, name: 'Qualification', competitionId, stageId},
            {id: 87, name: 'Final', competitionId, stageId}
          ])
        } else {
          resolve([])
        }
      })
    }
    return axios.get(this.getUrl('Competitions', competitionId, stageId))
      .then(({data}) => {
        return (data.Rounds[0] || []).map(each => {
          each.competitionId = competitionId
          each.stageId = stageId
          return each
        })
      })
  }

  getStartingListUrl (competitionId, stageId, roundId, group) {
    if (competitionId === EUROPEAN_CUP_BERN_2019_ID) {
      return `https://uiaa.result.site/api/uiaa/category_rounds/${roundId}/startlist`
    }
    return this.baseUrl + `GetStartingLists.php?competition=${competitionId}&stage=${stageId}&round=${roundId}&group=${group}`
  }

  getRankingListUrl (competitionId, stageId, roundId, group) {
    if (competitionId === EUROPEAN_CUP_BERN_2019_ID) {
      return `https://uiaa.result.site/api/uiaa/category_rounds/${roundId}/results`
    }
    return this.baseUrl + `GetResults.php?competition=${competitionId}&stage=${stageId}&round=${roundId}&group=${group}`
  }
}

export default UiaaApi



// WEBPACK FOOTER //
// ./src/api/UiaaApi.js